import { OPERATOR_MARKER_SOURCE_NAME } from 'modules/video-markers/domain/constants';
import { parseVmixRoot, VMIX_TRUE } from './parse-vmix-state';

/** Служебный инпут хоткея оператора в vMix. `isArmed` — шорткат нажат и метка ещё не снята. */
export interface VmixOperatorMarkerInput {
  key: string;
  isArmed: boolean;
}

/**
 * Служебный инпут хоткея (`OPERATOR_MARKER_SOURCE_NAME`) из XML `GET /api`. Шорткат оператора —
 * `LoopOn` на этот инпут, поэтому «нажато» = `loop="True"`; адаптер снимает метку `LoopOff` по
 * `key`. Инпута нет — `null`: оператор его не завёл, хоткея нет.
 *
 * Снято с vMix 28 (`__tests__/fixtures/vmix-api-operator-marker-armed.xml`):
 * `<input key="…" type="Colour" title="ImGame метка" … loop="True">`.
 */
export function parseVmixOperatorMarker(xml: string): VmixOperatorMarkerInput | null {
  const inputs = parseVmixRoot(xml).getElementsByTagName('input');
  const input = Array.from(inputs).find((element) => element.getAttribute('title') === OPERATOR_MARKER_SOURCE_NAME);
  const key = input?.getAttribute('key');

  if (!input || !key) return null;

  return { key, isArmed: input.getAttribute('loop') === VMIX_TRUE };
}
